module.exports = __webpack_public_path__ + "img/elena.f0db3a1d.jpeg";